const InternalError = Object.freeze({
    INVALID_ORIGIN: 'Risk provider iframe url origin is invalid',
    INVALID_IFRAME_URL: 'Risk provider iframe url is invalid',
});

module.exports = InternalError;
